import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _noop from "lodash/noop";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useContext, useMemo } from 'react';
var defaultFunctions = {
  onEnterTarget: _noop,
  onLeaveTarget: _noop,
  onLockTarget: _noop,
  onUnlockTarget: _noop
};
export var SharedHoverContext = React.createContext(undefined);
export var useSharedHoverContext = function useSharedHoverContext() {
  var bind = useContext(SharedHoverContext);
  var fns = bind !== null && bind !== void 0 ? bind : defaultFunctions;
  return useMemo(function () {
    return _objectSpread({
      enabled: !!bind
    }, fns);
  }, [bind, fns]);
};